import React from 'react';
import { FiCalendar, FiCheckCircle, FiClock } from 'react-icons/fi';
import { t } from 'i18next';
import moment from 'moment';
import HeaderPrinted from './HeaderPrinted';
import PrintedQuestion from './PrintedQuestion';

export function PrintedExamQuestions({ questionBook, course, orderingQuestions }) {
  return (
    <div className="printed-exam">
      <HeaderPrinted institution={course?.institution?.name} />

      <div className="printed-exam__info">
        <h2 className="printed-exam__title">{questionBook?.title}</h2>
        <div className="printed-exam__meta">
          <p className="printed-exam__meta-item">
            <FiCalendar className="printed-exam__icon" />
            <span>
              {t('exams.from')}
              <strong> {moment(questionBook?.['published-at']).format(t('datesForm.formatDate'))}</strong> {t('exams.at')} <strong>{moment(questionBook?.['published-at']).format('HH:mm')}</strong> {t('exams.to')}{' '}
              <strong> {moment(questionBook?.['finished-at']).format(t('datesForm.formatDate'))}</strong> {t('exams.at')} <strong>{moment(questionBook?.['finished-at']).format('HH:mm')}</strong>
            </span>
          </p>
          <p className="printed-exam__meta-item">
            <FiClock className="printed-exam__icon" />{' '}
            {questionBook?.['resolution-time'] != '01:00' ? (
              <span dangerouslySetInnerHTML={{ __html: t('exams.hoursDuration', { hours: questionBook?.['resolution-time'] }) }} />
            ) : (
              <span dangerouslySetInnerHTML={{ __html: t('exams.hourDuration', { hours: questionBook?.['resolution-time'] }) }} />
            )}
          </p>
          <p className="printed-exam__meta-item">
            <FiCheckCircle className="printed-exam__icon" /> {questionBook?.['question-count']} {t('exams.questions')}
          </p>
        </div>
        <p className="printed-exam__description">{questionBook?.['description']}</p>
      </div>

      <div className="printed-exam__questions">
        {orderingQuestions?.map((item, index) => (
          <PrintedQuestion
            key={item?.id ?? index}
            question={item}
            index={index}
          />
        ))}
      </div>
    </div>
  );
}
